import classnames from "classnames";
import React from "react";
import "./loader.scss";

interface LoaderProps {
  className?: string;
  children?: JSX.Element;
}

export const Loader = ({ className, children }: LoaderProps) => {
  return (
    <div className={classnames("spinner", className)}>
      <div className="bounce" style={{ animationDelay: "-0.32s" }} />
      <div className="bounce" style={{ animationDelay: "-0.16s" }} />
      <div className="bounce" />
    </div>
  );
};

interface Loader2Props {
  active?: boolean;
  className?: string;
}

enum SuccessLoaderStatus {
  "inactive",
  "active",
  "success",
}

interface SuccessLoaderState {
  status: SuccessLoaderStatus;
}

export class SuccessLoader extends React.Component<Loader2Props, SuccessLoaderState> {
  private resolve: () => void;

  public constructor(props) {
    super(props);
    this.state = {
      status: SuccessLoaderStatus.inactive,
    };
  }

  private onStatusToSuccess = () => {
    if (this.resolve) { this.resolve(); }

    new Promise<void>(resolve => {
      this.resolve = resolve;

      setTimeout(() => {
        this.setState({ status: SuccessLoaderStatus.inactive }, () => {
          resolve();
          this.resolve = null;
        });
      }, 2000);
    });
  }

  public componentWillReceiveProps(props: Loader2Props) {
    if (props.active) {
      this.setState({ status: SuccessLoaderStatus.active });
    }
    else if (this.props.active && !props.active) {
      this.setState({ status: SuccessLoaderStatus.success }, this.onStatusToSuccess);
    }
  }

  public render() {
    const loaderClassNames = classnames(
      "spinner",
      this.props.className,
      { active: this.state.status == SuccessLoaderStatus.active },
      { success: this.state.status == SuccessLoaderStatus.success },
    );

    return (
      <div className={loaderClassNames} />
    );
  }

}
